import FrontCubeData from '../../../frontCubeData';

function setDropAreaStyle(cube: CubeNode): void {
    let height: LogicsicsMeasurement = FrontCubeData.getLogicValue(cube.id, 'depth') || 300;
    let width: LogicsicsMeasurement = FrontCubeData.getLogicValue(cube.id, 'width') || 400;

    cube.jView.find('.J_ElementFreezerSlot').css({
        left: '',
        top: '',
        width: width,
        height: height
    });
}

export {
    setDropAreaStyle
};
